module.exports = __webpack_public_path__ + "img/the-netherlands-ischemic-heart-disease-female.8045409c.png";